import { cn } from "@au-schein-de/au-ui-library";
import { CheckoutQuestionnaireHeaderPattern } from "~/features/checkout/checkout-questionnaire-header-pattern.component";
import { getExclusiveProductsBackgroundPatternVisibilityClass } from "./exclusive-products-pdp.logic";

interface ExclusiveProductsBackgroundPatternProps {
	productCount: number;
}

export function ExclusiveProductsBackgroundPattern({
	productCount,
}: ExclusiveProductsBackgroundPatternProps) {
	return (
		<CheckoutQuestionnaireHeaderPattern
			className={cn(
				"pointer-events-none absolute right-0 top-[11px] h-[243px] w-[313px] text-ansay-900 opacity-[0.03]",
				getExclusiveProductsBackgroundPatternVisibilityClass(productCount),
			)}
		/>
	);
}
